<v4-custom-select
  [showTextItem]="renderText"
  [textItem]="renderText"
  [size]="size"
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
>
  <div class="v4-layout-dropdown" style="padding: 0">
    <div class="flex flex-row">
      <div class="flex-1 max-h-[300px] overflow-y-auto">
        <div
          *ngFor="let opt of listOfOptions[0]; trackBy: trackByValue"
          class="item py-[5px] pr-4 pl-3 cursor-pointer"
          [class.active]="opt.value === leftValue"
          (click)="onSelectLeft(opt.value)"
        >
          {{ opt.label }}
        </div>
      </div>
      <div class="flex-1 max-h-[300px] overflow-y-auto">
        <div
          *ngFor="let opt of listOfOptions[1]; trackBy: trackByValue"
          class="item py-[5px] pr-4 pl-3 cursor-pointer whitespace-nowrap"
          [class.active]="opt.value === rightValue"
          (click)="onSelectRight(opt.value)"
        >
          {{ opt.label }}
        </div>
      </div>
    </div>
  </div>
</v4-custom-select>

<!-- <div class="host-cascaded-time-picker-v2" *ngIf="false">
  <div
    class="selector"
    nz-dropdown
    [nzDropdownMenu]="menu"
    nzTrigger="click"
    [nzBackdrop]="false"
    (nzVisibleChange)="onVisibleChange($event)"
  >
    <div class="selection" [class.placeholder]="!renderText">{{ renderText || placeholder }}</div>
    <i class="arrow" nz-icon nzType="down" nzTheme="outline"></i>
  </div>

  <nz-dropdown-menu #menu>
    <div class="host-cascaded-time-picker-v2-dropdown-panel">
      <div class="panel-container">
        <div class="left-c column">
          <div
            *ngFor="let opt of listOfOptions[0]; trackBy: trackByValue"
            class="item"
            [class.active]="opt.value === leftValue"
            (click)="onSelectLeft(opt.value)"
          >
            {{ opt.label }}
          </div>
        </div>
        <div class="right-c column">
          <div
            *ngFor="let opt of listOfOptions[1]; trackBy: trackByValue"
            class="item"
            [class.active]="opt.value === rightValue"
            (click)="onSelectRight(opt.value)"
          >
            {{ opt.label }}
          </div>
        </div>
      </div>
    </div>
  </nz-dropdown-menu>
</div> -->
